import { createSlice } from "@reduxjs/toolkit";
import { DashboardSettings } from "../../Typings/Dashboard";
import { AdGroupType } from "../../Enums/AdGroupType";

export const DashboardSettingsSlice = createSlice({
  name: "dashboardSettings",
  initialState: {
    value: { groupType: AdGroupType.Category } as DashboardSettings,
  },
  reducers: {
    updateSettings: (state, action) => {
      state.value = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { updateSettings } = DashboardSettingsSlice.actions;

export const selectDashboardSettings = (state: any) => state.dashboardSettings.value as DashboardSettings;

export default DashboardSettingsSlice.reducer;
